import React from 'react';
import { EmailCaptureForm } from '../../components/EmailCaptureForm';
import './LandingPage.css';
import { BsStars, BsCamera, BsGraphUpArrow } from 'react-icons/bs';

export default function DreamPhysiqueLandingPage() {
  return (
    <div className="landing-page">
      <div className="landing-hero" data-fast-scroll="dream_physique_hero_view">
        <img src="/images/GymBuddy.png" alt="GymBuddy" className="landing-logo" onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/images/PokerBuddy.png'; }} />
        <h1 className="landing-title">Build Your Dream Physique</h1>
        <p className="landing-subtitle">
          Transform your body with AI-powered coaching. Track progress with photos, get personalized workout plans, and achieve the physique you've always wanted.
        </p>
        
        {/* Hero Image - Part of CTA */}
        <div className="hero-image-container">
          <img src="/images/DreamPhysique.png" alt="Dream Physique Transformation" className="hero-image" />
        </div>

        <EmailCaptureForm campaign="dream_physique" placeholder="Enter your email to start your transformation" />
      </div>

      <div className="landing-content" data-fast-scroll="dream_physique_benefits_view" data-fast-scroll-threshold="0.5">
        <div className="benefit-grid">
          <div className="benefit-card">
            <div className="benefit-title">
              <BsCamera style={{ color: '#213e70' }} />
              <span>Visual Progress Tracking</span>
            </div>
            <p className="benefit-desc">
              Take progress photos and watch your transformation unfold. Our AI analyzes your photos to track muscle growth and body composition changes.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsStars style={{ color: '#213e70' }} />
              <span>AI-Powered Plans</span>
            </div>
            <p className="benefit-desc">
              Get workout routines tailored to your goals. Whether you're building muscle, losing fat, or both—your plan adapts as you progress.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsGraphUpArrow style={{ color: '#213e70' }} />
              <span>Consistent Results</span>
            </div>
            <p className="benefit-desc">
              Stay accountable with smart reminders and progress insights. See exactly what's working and adjust your strategy in real-time.
            </p>
          </div>
        </div>

        <div className="app-preview-section" data-fast-scroll="dream_physique_preview_view">
          <h2 className="app-preview-title">Your Transformation Toolkit</h2>
          <div className="app-preview-grid">
            <img src="/images/image.png" alt="App Preview 1" className="app-preview-image" />
            <img src="/images/image1.png" alt="App Preview 2" className="app-preview-image" />
            <img src="/images/image3.png" alt="App Preview 3" className="app-preview-image" />
            <img src="/images/image4.png" alt="App Preview 4" className="app-preview-image" />
          </div>
        </div>
      </div>

      <footer className="landing-footer" data-fast-scroll="dream_physique_footer_view">
        © {new Date().getFullYear()} GymBuddy. All rights reserved.
      </footer>
    </div>
  );
}
